export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.companyId = item != null ? item.companyId : ''
        this.name = item != null ? item.name : ''
        this.tag = item != null ? item.tag : ''
        this.coupling = item != null ? item.coupling : null
        this.mailUsername = item != null ? item.mailUsername : ''
        this.mailIsActive = item != null ? item.mailIsActive : false
        this.modules = item != null ? item.modules : ''

        this.dagboek = item != null ? item.dagboek : ''
        this.crediteur = item != null ? item.crediteur : ''
        this.btwHoog = item != null ? item.btwHoog : ''
        this.btwLaag = item != null ? item.btwLaag : ''

        this.snelstartOnlineLinkingKey = item != null ? item.snelstartOnlineLinkingKey : ''

        this.primaDatabase = item != null ? item.primaDatabase : ''

        this.werkExpertUsername = item != null ? item.werkExpertUsername : ''
        this.werkExpertPassword = item != null ? item.werkExpertPassword : ''
        this.werkExpertTenantId = item != null ? item.werkExpertTenantId : ''
    }
}